/**
 * Calculates percentage/currency for given value
 */
function percentage(mode, purchaseElement, valueElement) {

    var value = valueElement.parseNumber({format: "#,##0.00", locale: "de"});
    var purchase = purchaseElement.parseNumber({format: "#,##0.00", locale: "de"});

    var percentaged = value;

    if ('currency' === mode) {
        percentaged = Math.round(purchase * (value / 100) * 100) / 100;
    } else if ('percent' === mode) {
        percentaged = Math.round((100 / purchase) * value * 100) / 100;
    } else {
        percentaged = '0';
    }

    if (isNaN(percentaged)) {
        percentaged = '0';
    }

    valueElement.val(percentaged);

    valueElement.formatNumber({format: "#,##0.00", locale: "de"});
    purchaseElement.formatNumber({format: "#,##0.00", locale: "de"});
}

$(document).ready(function () {

    // make sure, numbers are formatted pretty after first page load
    $.each($('form#calculation').find('.numeric'), function (key, element) {
        $(element).formatNumber({format: "#,##0.00", locale: "de"});
    });

    $(document).on('submit', 'form#calculation', function (event) {
        // make sure, numbers are parsed to valid float values before submitting
        $.each($('form#calculation').find('.numeric'), function (key, element) {
            if (false === $.isNumeric($(element).val())) {
                $(element).parseNumber({format: "#,##0.00", locale: "de"});
            }
        });
    });

    $(document).on('change', 'form#calculation', function (event) {
        var container = $('.portal-calculation');
        var form = container.find('form.form-leasing');

        // only if product class and list price selected. but if list price has changed, do it
        // @todo does not work, since form must be evaluated directly
        // to show date of machine on used once (and other stuff)
        /*if ((form.find('select#product_class').val() == '' && $(event.target).attr('id') != 'product_class') ||
            (form.find('input#list_price').val() == '0,00' && $(event.target).attr('id') != 'list_price') ||
            (form.find('input#list_price').val() == 0 && $(event.target).attr('id') != 'list_price')) {
            return false;
        }*/

        $(this).find('input#target').val($(event.target).attr('name'));

        if ($(event.target).attr('id') === 'paydown_method') {
            percentage($(event.target).val(), $('input#purchase_price'), $('input#paydown'));
        }

        if ($(event.target).attr('id') === 'endingrate_method') {
            percentage($(event.target).val(), $('input#purchase_price'), $('input#ending_rate'));
        }

        // make sure, numbers are parsed to valid float values before submitting
        $.each($('form#calculation').find('.numeric'), function (key, element) {
            if (false === $.isNumeric($(element).val())) {
                $(element).parseNumber({format: "#,##0.00", locale: "de"});
            }
        });

        container.easyOverlay('start');

        $('<input>').attr({
            type: 'hidden',
            id: 'ajax',
            name: 'ajax',
            value: 1
        }).appendTo(form);

        $('<input>').attr({
            type: 'hidden',
            id: 'calculate',
            name: 'calculate',
            value: 1
        }).appendTo(form);

        $.post('portal/calculation/new', form.serialize(), function (response) {
            container.replaceWith(response);
            container.easyOverlay('stop');

            // make sure, numbers are formatted pretty after posting is done
            $.each($('form#calculation').find('.numeric'), function (key, element) {
                $(element).formatNumber({format: "#,##0.00", locale: "de"});
            });

            var tabindex = $('#' + $(event.target).attr('id')).attr('tabindex');
            tabindex++;
            var next = $('form [tabindex=' + tabindex + ']');
            if (next.length) {
                next.focus().select();
            }
        });
    });
});


$(document).ready(function () {
    $("form#details input#company").autocomplete({
        source: function (request, response) {
            $.getJSON(window.location.protocol + '//' + window.location.hostname + '/portal/customer/replicate',
                {'term': request.term},
                function (data) {
                    return response(data);
                }
            );
        },
        select: function (event, ui) {
            $('form#details').easyOverlay('start');
            $.ajax({
                url: window.location.protocol + '//' + window.location.hostname + '/portal/calculation/importcustomer/customer/' + ui.item.id,
                success: function (data) {
                    $('#customer_reference_id').val(data.customer_reference_id);

                    $('#salutation').val(data.customer.salutation);
                    $('#contact_person').val(data.customer.contact_person);
                    $('#company').val(data.customer.company);
                    $('#street_number').val(data.customer.street_number);
                    $('#zip').val(data.customer.zip);
                    $('#city').val(data.customer.city);
                    $('#phone').val(data.customer.phone);
                    $('#lax').val(data.customer.lax);
                    $('#email').val(data.customer.email);

                    $('form#details').easyOverlay('stop');
                }
            });
        }
    });
});

$(document).ready(function () {
    $("form#calculation input#class").autocomplete({
        source: function (request, response) {
            $.getJSON(window.location.protocol + '//' + window.location.hostname + '//portal/dealer/classes',
                {'term': request.term, 'product_class': $('#product_class').find(":selected").val()},
                function (data) {
                    return response(data);
                }
            );
        },
        change: function (event, ui) {
            $(this).change();
        }
    });
});

$(document).ready(function () {
    $(document).on('change', 'form#calculation select#duration', function () {
        $('form#calculation input#duration_changed').val(1);
    });
});

$(document).ready(function () {
    $(document).on('change keypress', 'form.form-leasing input, form.form-leasing textarea, form.form-leasing select, form.form-leasing checkbox, form.form-leasing radio', function () {
        $(this).parents('.has-error').removeClass('has-error');
    });
});

$(document).ready(function () {
    $(document).on('click', '.portal-calculation .panel .panel-heading a', function (event) {
        event.preventDefault();
        var _that = $(this);
        var form = $('form.form-leasing');
        $(document).on('submit', 'form.form-leasing', function () {
            var input = $('<input>').attr('type', 'hidden').attr('name', 'tab_step').val(_that.data('step'));
            $(this).append($(input));
        });
        form.submit();
    });
});

$(document).ready(function () {
    var buttonName = 'btnNext';
    $(document).on('click', 'form#calculation #calculate, form#calculation #btnNext', function (event) {
        if ($('#_type_').val() == 'longtime_hire') {
            event.preventDefault();
            buttonName = this.name;
            var dialog = $('#longterm_hire_dialog');
            bootbox.dialog({
                message: dialog.html(),
                title: dialog.data('title'),
                buttons: {
                    confirm: {
                        label: 'OK',
                        className: "btn-primary",
                        callback: function () {
                            var form = $("form#calculation");
                            $('<input>').attr({
                                type: 'hidden',
                                id: buttonName,
                                name: buttonName,
                                value: 1
                            }).appendTo(form);
                            form.submit();
                        }
                    }
                }
            });
        }
    });
});